import { render, staticRenderFns } from "./UpdateKeyword.vue?vue&type=template&id=c1d68e3a&"
import script from "./UpdateKeyword.vue?vue&type=script&lang=js&"
export * from "./UpdateKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports